import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

/**
 * While a report edition is queued or generating, refreshes the page every
 * few seconds as a Turbo morph (the page declares turbo-refresh-method=morph
 * and scroll=preserve): only the template card's progress changes, the
 * scroll position stays.
 *
 * An interval, not a one-shot timeout: a morph keeps this element in place,
 * so connect() does not run again after a refresh. The interval stops when
 * no edition is pending any more — the element is then not rendered, and
 * disconnect() clears it.
 */
export default class extends Controller {
  static values = { interval: { type: Number, default: 4000 } };

  connect() {
    this.timer = setInterval(() => {
      if (document.visibilityState === "visible") {
        Turbo.visit(window.location.href, { action: "replace" });
      }
    }, this.intervalValue);
  }

  disconnect() {
    clearInterval(this.timer);
  }
}
